<template>
  <div class="">
    <input ref="input" type="file" id="uploader" @change="handleFiles" />
    <label class="avatar-btn-add" for="uploader"></label>
    <div>
      {{ imgSrc }}
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      imgSrc: "", // 初始化为空字符串
      imageUrl:
        "https://tse3-mm.cn.bing.net/th/id/OIP-C.GorWoR4wimGAoFxfeuCoigHaEW?rs=1&pid=ImgDetMain",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.convertImageUrlToBase64();
  },
  methods: {
    // 本地图片转bes64
    handleFiles(event) {
      // 从 input 元素中获取 files: FileList
      let files = event.target.files[0];
      const reader = new FileReader();
      console.log(reader);
      reader.onload = (e) => {
        // 当文件读取完成时，将读取到的数据（URL）赋值给imageUrl
        this.imgSrc = e.target.result;
      };
      reader.readAsDataURL(files); // 读取文件内容作为DataURL
      console.log(this.imgSrc);
    },
    // 线上图片转bes64
    // convertImageUrlToBase64() {
    //   fetch(this.imageUrl)
    //     .then((response) => response.blob())
    //     .then((blob) => {
    //       return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => resolve(reader.result);
    //         reader.onerror = (error) => reject(error);
    //         reader.readAsDataURL(blob);
    //       });
    //     })
    //     .then((base64Data) => {
    //       // 使用箭头函数确保 this 指向 Vue 实例
    //       this.imgSrc = base64Data; // 现在可以正确地将 base64Data 赋值给 this.imgSrc
    //       console.log(this.imgSrc);
    //     })
    //     .catch((error) => {
    //       console.error("无法将图片 URL 转换为 Base64:", error);
    //     });
    // },
  },
};
</script>

<style scoped lang="less">
.sheet-container {
  padding-left: 30px;
  padding-right: 30px;
}
</style>
